// extracted by mini-css-extract-plugin
module.exports = {"root":"SockyZoom_root__nlZUJ","overlay":"SockyZoom_overlay__3Fh2r"};